// extracted by mini-css-extract-plugin
export default {"singleOtpInputField":"OtpForm_singleOtpInputField__TZMd6"};